import React from 'react';
import { BsPlus } from 'react-icons/bs';
import { Icon, IconButton, Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger, useDisclosure } from '@chakra-ui/react';

import Content from '../Content';

function PopoverButton() {
  const { onOpen, onClose, isOpen } = useDisclosure();
  return (
    <Popover
      closeOnBlur={false}
      closeOnEsc={false}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
    >
      <PopoverTrigger>
        <IconButton
          icon={<Icon as={BsPlus} boxSize={5} />}
          size="xs"
          variant="textPrimary"
        />
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>
          <Content type="popover" onClose={onClose} />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default PopoverButton;
